/* __next_internal_client_entry_do_not_use__ SDUICategoryPagePrefetcher auto */ // eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useFilterablePaginatedSectionQuery } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Fetching/useFilterablePaginatedSectionQuery";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useBrowseLayoutQuery } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/v3/useBrowseLayoutQuery";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useIsFullWidthCategory } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useIsFullWidthCategory";
import { useCurrentNavigationPath } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentNavigationPath";
import { IFilterablePaginatedSection } from "@faire/web-api--source/indigofair/data/IFilterablePaginatedSection";
import { IGetSDUIFilteredComponentsRequest } from "@faire/web-api--source/indigofair/data/IGetSDUIFilteredComponentsRequest";
import { ViewLayoutPlacement } from "@faire/web-api--source/indigofair/data/ViewLayoutPlacement";
var SEASONAL_HUB_PAGE_SIZE = 36;
var FULL_WIDTH_PAGE_SIZE = 40;
export var SDUICategoryPagePrefetcher = function() {
    var navigationPath = useCurrentNavigationPath();
    var isFullWidthCategory = useIsFullWidthCategory();
    useBrowseLayoutQuery(ViewLayoutPlacement.TOP);
    useBrowseLayoutQuery(ViewLayoutPlacement.FPS);
    var pageSize = isFullWidthCategory ? FULL_WIDTH_PAGE_SIZE : SEASONAL_HUB_PAGE_SIZE;
    var filterablePaginatedSection = IFilterablePaginatedSection.build({
        get_s_d_u_i_filtered_components: IGetSDUIFilteredComponentsRequest.build({
            page_identifier: {
                category_page: {
                    navigation_path: navigationPath
                }
            },
            pagination_data: {
                page_number: 1,
                page_size: pageSize
            }
        }),
        get_s_d_u_i_navigation_tree_request: {
            navigation_path: navigationPath
        }
    });
    useFilterablePaginatedSectionQuery(filterablePaginatedSection);
    return null;
};
